import * as Sentry from '@sentry/react';
import { memo } from 'react';
import { useNavigate, useRouteError } from 'react-router-dom';

import HeaderCatalog from '../../components/HeaderCatalog';
import ArrowRightIcon from '../../components/SVGIcons/ArrowRightIcon';
import mediaQueries from '../../utils/media-query/media-query-constants';
import useMediaQuery from '../../utils/media-query/media-query-hook';
import classes from './page404.module.scss';

function Page404() {
  const error = useRouteError();

  Sentry.captureException(error);

  const isMobile = useMediaQuery(mediaQueries.mobile);

  const navigate = useNavigate();

  return (
    <div className={classes.mainPageContainer}>
      <HeaderCatalog
        className={classes['catalog-vacancies__header']}
        isSticked={false}
        colored
      />
      <div className={classes.errorContainer}>
        <h1>404</h1>
        <h2>{'такая страница\nне найдена'}</h2>
        <button
          type="button"
          onClick={() => {
            navigate('/');
          }}
        >
          {isMobile ? 'Вернуться' : 'Вернуться на главную'}
          <ArrowRightIcon fill="white" />
        </button>
      </div>
    </div>
  );
}

export default memo(Page404);
